import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Alert, Button, Form, FormField, TextInput } from "../../ui";
import type { FlashMessage } from "../../../types/state";

interface FormErrorItem {
  code: string;
  message: string;
}

interface ResetPasswordFormProps extends WithTranslation {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  switchModal: (display: boolean) => void;
  formError?: FormErrorItem[];
  message?: FlashMessage | null;
}

function ResetPasswordForm({
  t,
  onChange,
  onSubmit,
  switchModal,
  formError,
  message,
}: ResetPasswordFormProps) {
  const emailId = "ResetPasswordForm-email";
  const formErrorId = "ResetPasswordForm-errors";
  const messageId = "ResetPasswordForm-message";

  return (
    <Form action="/" onSubmit={onSubmit} className="Form LoginForm ResetPasswordForm" noValidate>
      {formError && formError.length > 0 ? (
        <Alert variant="error" className="Form-message error" id={formErrorId}>
          {formError.map((error) => (
            <span key={error.code} className="Form-messageLine">
              {error.message}
            </span>
          ))}
        </Alert>
      ) : null}
      {message ? (
        <Alert id={messageId} variant={message.type} className={"Form-message " + message.type}>
          {message.content}
        </Alert>
      ) : null}
      <FormField
        className="Form-line"
        label={t("reset.label_email")}
        htmlFor={emailId}
        hint={t("reset.info_email")}
      >
        <TextInput
          className="Form-input LoginForm-email"
          type="email"
          name="email"
          id={emailId}
          onChange={onChange}
          aria-describedby={[formError?.length ? formErrorId : null, message ? messageId : null]
            .filter(Boolean)
            .join(" ")}
        />
      </FormField>

      <Button variant="ghost" className="AuthPage-secondaryLink" onClick={() => switchModal(true)}>
        Adresse email oubliée ?
      </Button>
      <div className="Form-line isActionLine">
        <Button type="submit" size="lg" className="Button LoginForm-submit isLarge">
          {t("reset.button_reset")}
        </Button>
      </div>
    </Form>
  );
}

export default compose(withTranslation())(ResetPasswordForm);
